let webgl2: boolean | undefined

/**
 * Whether this browser can create a WebGL2 context. It probes once, caches the result,
 * and releases the probe context straight away (`WEBGL_lose_context`), because browsers
 * cap the number of live contexts.
 */
export function hasWebGL2(): boolean {
  if (webgl2 !== undefined) return webgl2
  if (typeof document === 'undefined') return false

  try {
    const canvas = document.createElement('canvas')
    const gl = canvas.getContext('webgl2')
    webgl2 = gl !== null
    gl?.getExtension('WEBGL_lose_context')?.loseContext()
  } catch {
    webgl2 = false
  }
  return webgl2
}
